<template>
  <div class="form-page">
    <g-title tag="h1" size="s">
      TACK för att du vill hjälpa oss förstå mer om unga på nätet.
    </g-title>
    <p>
      Det här testet är för barn mellan 10 år och 17 år. Det betyder att språket
      och berättelserna inte passar dig som är yngre än 10 år.
    </p>
    <p>Du är hjärtligt välkommen tillbaka när du är lite äldre.</p>
    <p>
      Om du undrar om något om kroppen eller sex så kan du hitta mer om det här:
      <a href="https://www.kpwebben.se/" style="text-decoration: underline;">
        KPwebben
      </a>
    </p>
  </div>
</template>
<script>
export default {};
</script>

<style scoped></style>
